import matchEndOfPath from "./matchEndOfPath";

export default function makeGetBaseLink(pathEndings: string[]) {
  return (currentPathname: string) => {
    const matchedEnding = pathEndings.find(ending =>
      matchEndOfPath(currentPathname, ending)
    );

    if (matchedEnding) {
      // @ts-ignore - we've checked this is not undefined above
      const { url: matchedPortionOfTheUrl } = matchEndOfPath(
        currentPathname,
        matchedEnding
      );

      const regex = new RegExp(`${matchedPortionOfTheUrl}$`);
      const trimmedPath = currentPathname.replace(regex, "");

      return trimmedPath || "/";
    }

    return currentPathname;
  };
}
